import { useNavigate } from 'react-router-dom'
import CustomButton from '../../Components/CustomButton'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__content">
        <div className="not-found__icon">
          <img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="Sterling Logistics" />
        </div>

        <h1 className="not-found__code">404</h1>

        <h2 className="not-found__title">Page Not Found</h2>

        <p className="not-found__message">
          Looks like this shipment went off-route. The page you're looking for
          doesn't exist or may have been moved.
        </p>

        <CustomButton label="Back To Home" onClick={() => navigate('/')} />
      </div>
    </div>
  )
}

export default NotFound
